<div class="md:h-[90vh]" *transloco="let t">
  <div class="border-b border-b-grey-300 pt-2xl pb-md text-center md:border-0">
    <h1 class="heading-md">{{ t('createJobRequest.intentions.title') }}</h1>
    <h2 class="heading-xl">{{ offering!.label }}</h2>
  </div>
  <div class="h-layout bg-white md:flex md:justify-center md:bg-transparent">
    <div class="bg-white p-md md:w-[36rem] md:rounded-3 md:p-xl md:shadow-1">
      <h3 class="mb-md text-center heading-lg">{{ t('createJobRequest.intentions.question') }}</h3>
      <ul>
        @for (intention of intentions; track intention; let last = $last) {
          <li [class.mb-md]="!last">
            <a (click)="selectIntention(intention.slug)">
              <cft-horizontal-list-card
                elevation="flat"
                [icon]="intention.icon"
                [title]="intention.label"
              ></cft-horizontal-list-card>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
